var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    d: "M6.8 9H21.2C22.19 9 23 9.61875 23 10.375V18.625C23 19.3813 22.19 20 21.2 20H6.8C5.81 20 5 19.3813 5 18.625V10.375C5 9.61875 5.81 9 6.8 9Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.375C2 5.36908 2.00066 5.35468 2.01597 5.32715C2.03272 5.29703 2.0683 5.25013 2.13579 5.19858C2.27412 5.09291 2.50668 5 2.8 5H17.2C17.4933 5 17.7259 5.09291 17.8642 5.19858C17.9317 5.25013 17.9673 5.29703 17.984 5.32715C17.9993 5.35468 18 5.36908 18 5.375V9H20V5.375C20 4.61689 19.5923 4.0019 19.0783 3.60924C18.5641 3.21647 17.8967 3 17.2 3H2.8C2.10332 3 1.43588 3.21647 0.92171 3.60924C0.407682 4.0019 0 4.61689 0 5.375V13.625C0 14.3831 0.407682 14.9981 0.92171 15.3908C1.43588 15.7835 2.10332 16 2.8 16H5V14H2.8C2.50668 14 2.27412 13.9071 2.13579 13.8014C2.0683 13.7499 2.03272 13.703 2.01597 13.6728C2.00066 13.6453 2 13.6309 2 13.625V5.375Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.b93e7af46729a91d62a39909dc127533.svg";
export { ForwardRef as ReactComponent };